import { BehaviorSubject, Subject } from 'rxjs';
import { TariffModel } from '../../../models/price/tariff-model';
import { ConsumptionData, ProductionData } from '../../../models/analysis/solar-calculator-request';
import { PriceType } from '../../../models/price/price';

export class CalculatorInputManager {

  country: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  supplier: Subject<any> = new Subject<any>();
  tariff_group: Subject<any> = new Subject<any>();
  site_data_type: Subject<any> = new Subject<any>();
  location: Subject<any> = new Subject<any>();
  type_calculation: Subject<any> = new Subject<any>();

  tariffHasTwoPrices: boolean;
  tariffModelValues: TariffModel[];
  consumptionFileData: ConsumptionData[];

  productionData: ProductionData[];
  drawingModeActive: boolean;
  priceType: PriceType;
}
